import { render, staticRenderFns } from "./FaqProfile.vue?vue&type=template&id=1efe2fb6"
import script from "./FaqProfile.vue?vue&type=script&lang=js"
export * from "./FaqProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports